<!--
 * @Description: ofbu客户详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-13 14:21:53
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        :customLabel="$t('common.contactName')"
        :customValue="data?.contact?.name"
      >
        <a-tabs @change="changeTabs">
          <a-tab-pane key="1" :tab="$t('common.baseTabs')">
            <baseMessage :disabled="true" formItemView :data="data" :type="type" :hideOk="true" />
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('common.concatTabs')">
            <TabsContacts :contactRefId="route.query.cosId" appId="cos_ofbu"  :hideOk="true" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/overseasSales/customerCenter'
import { useRoute } from 'vue-router'
defineProps({
  type: {
    type: String
  }
})
const route = useRoute()
const data = ref({})
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === '1') {
    fetch()
  }
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default {
  name: 'FbuClientsView'
}
</script>
<style lang="scss" scoped></style>
